"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _FlexContainer = _interopRequireDefault(require("../../FlexContainer"));

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
    props: customLabel, disabled, id, noLabel, onChange, value, styles
 */
var CheckInput = function CheckInput(_ref) {
  var customLabel = _ref.customLabel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      onChange = _ref.onChange,
      t = _ref.t,
      fieldDescription = _ref.fieldDescription,
      labelTooltip = _ref.labelTooltip,
      value = _ref.value,
      styles = _ref.styles,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      innerWrapperStyle = _ref.innerWrapperStyle,
      postErrorHandler = _ref.postErrorHandler,
      postErrors = _ref.postErrors,
      requiredSelection = _ref.requiredSelection,
      requiredSelectionErrorMessage = _ref.requiredSelectionErrorMessage,
      errorHandler = _ref.errorHandler;
  var validationsArray = requiredSelectionErrorMessage && ['REQUIRED_SELECTION'];

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      errorHandler: errorHandler,
      requiredSelection: requiredSelection,
      requiredSelectionErrorMessage: requiredSelectionErrorMessage,
      id: id
    });
  };

  var inputChangeHandler = function inputChangeHandler(id) {
    if (postErrors) {
      postErrorHandler(id);
    }

    onChange(id, !value);
  };

  (0, _react.useEffect)(function () {
    if (validationsArray) {
      inputValidation(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  return _react.default.createElement(_FlexContainer.default, {
    column: true
  }, _react.default.createElement(_FlexContainer.default, {
    style: innerWrapperStyle
  }, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip,
    margin: 0
  }), _react.default.createElement("div", {
    style: {
      margin: '-12px'
    }
  }, _react.default.createElement(_core.Checkbox, {
    "data-cy": "checkbox-".concat(id),
    disabled: disabled,
    color: "primary",
    onChange: function onChange() {
      return inputChangeHandler(id);
    },
    checked: value || false,
    styles: styles
  }))), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = _react.default.memo(CheckInput, _isEqual.default);

exports.default = _default;